import type React from 'react';
import type { IGetApplicationFormInfoServiceRes } from '@/api/Rover/ApplicationForm/types';
import type { Section } from '@/components/UI/JsonForm/JsonInputRenderer/types';

export interface IApplicationFormStep {
  title: string;
  sections: Section[];
  component?: React.FC;
  isReview?: boolean;
}

export type TApplicationFormType = 'CLIENT_APPLICATION' | 'PARTNER_PROPOSAL';

export interface IApplicationDetails {
  applicationData: any;
  files?: any;
}

export enum EFormConfigType {
  TEMPLATE = 'TEMPLATE',
  FREE = 'FREE',
}

export interface IApplicationFormProps {
  formData: IGetApplicationFormInfoServiceRes;
}
